import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { Subscription } from 'rxjs';
import { WalletService } from '../../../angular-wallet-base/services/wallet.service';
import { AlertController, NavController } from '@ionic/angular';
import { SetSetupMnemonicAction } from '../../../angular-wallet-base/actions/setup.actions';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { MembersPortalService } from 'src/app/angular-wallet-base/services/members-portal.service';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';

@Component({
  selector: 'enter-recovery-phrase',
  templateUrl: 'enter-recovery-phrase.page.html',
  styleUrls: ['enter-recovery-phrase.page.scss']
})
export class EnterRecoveryPhrasePage implements OnInit, OnDestroy {

  public mnemonic: string = '';
  private subscriptions = new Subscription();
  private mnemonicValid: boolean = false;
  public showLoader: boolean = false;
  readonly type: string;
  public isLodeLinked;
  public isDesktopMode;

  constructor(
    private nav: NavController,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private walletService: WalletService,
    private appMode: AppModeService,
    public alertController: AlertController,
    private membersPortalService: MembersPortalService,
    private translate: TranslateService
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    this.type = this.route.snapshot.params['type'] ? this.route.snapshot.params['type'] : 'new';
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  completeSetup() {
    this.showLoader = true;
    setTimeout(async () => {
      const bip39 = (window as any).bip39;
      this.mnemonicValid = bip39.validateMnemonic(this.mnemonic.toLowerCase().trim());

      if (!this.mnemonicValid) {
        const alert = await this.alertController.create({
          header: await this.translate.get('settings.alert_title_reset_warning').toPromise(),
          subHeader: await this.translate.get('settings.invalid_mnemonic_entered').toPromise(),
          message: await this.translate.get('settings.invalid_mnemonic_try_again').toPromise(),
          buttons: ['OK']
        });
        this.showLoader = false;
        return await alert.present();
      }

      // For recover wallet we are encrypted the phrase
      if(this.type === 'recover') { 
        var isValidEncPhrase = await this.walletService.compareEncryptedPhrase(this.mnemonic);
        if(!isValidEncPhrase) {
          const alert = await this.alertController.create({
            header: await this.translate.get('settings.alert_title_reset_warning').toPromise(),
            subHeader: await this.translate.get('settings.invalid_mnemonic_entered').toPromise(),
            message: await this.translate.get('settings.invalid_mnemonic_try_again').toPromise(),
            buttons: ['OK']
          });
          this.showLoader = false;
          return await alert.present();
        }
      }
      // For new wallet we are encrypted the phrase
      if(this.type === 'new') {
        this.walletService.setEncryptedPhrase(this.mnemonic);
      }
      
      this.store.dispatch(new SetSetupMnemonicAction({ mnemonic: this.mnemonic.toLowerCase().trim() }));
      this.showLoader = false;

      /*
        switch (this.type) {
          case 'new':
            await this.nav.navigateForward('/setup/setup-capture-email');
            break;
          case 'recover':
            this.completeSetupRecover();
            break;
          default:
            await this.nav.navigateForward('/setup/setup-capture-email');
            break;
        }
      */

        this.completeSetupRecover()
    }, 10);
  }

  goBack() {
    this.nav.back();
  }

  clearText() {
    this.mnemonic = '';
  }
  
  completeSetupRecover() {
    setTimeout(async () => {
      await this.walletService.completeSetup();
      await this.nav.navigateRoot('/wallet/assets');
    }, 100)
  }

}
